import PREVIOUS_SEARCH_COUNT from 'constants/previous-search-count';
import appCONST from 'constants/app.constants';

export default function CarsFactory(
    $http,
    $state,
    $stateParams,
    $q,
    moment,
    mapsFactory,
    userService,
    l10nService,
    TimeLocationConstructor,
    defaultTimeFactory,
    carsRequestDataFactory,
    prepareCarMatrixFactory
) {
    'ngInject';

            let formData = null;
            let searchResults = null;
            const defaultFilters = {
                AreaFilter: [],
                CarProviderFilter: [],
                CarClassFilter: [],
                FuelTypeFilter: [],
                MileageFilter: [],
                BootSizeFilter: [],
                TransmissionTypeFilter: [],
                PassengerCapacityFilter: [],
                TotalPriceFilter: [],
                ShuttleInformationFilter: [],
            };
            let filters = angular.copy(defaultFilters);
            const timeOptions = defaultTimeFactory && defaultTimeFactory.getTimeOptions();

            const options = {
                timeOptions,
                pickUpTimeOptions: timeOptions,
                dropOffTimeOptions: timeOptions,
                pickUpTime: defaultTimeFactory && defaultTimeFactory.getDefaultTime(),
                dropOffTime: defaultTimeFactory && defaultTimeFactory.getDefaultTime(),
                pickUpDate: null,
                dropOffDate: null,
            };

            return {
                pickUpAddress: '',
                dropOffAddress: '',
                options,
                carsRequestData: carsRequestDataFactory,
                formats: defaultTimeFactory && defaultTimeFactory.defaultFormats,
                getTopPreviousSearches: getFunctionForLoadPreviousSearches(PREVIOUS_SEARCH_COUNT.TOP),
                getAllPreviousSearches: getFunctionForLoadPreviousSearches(PREVIOUS_SEARCH_COUNT.EXTENDED),
                getSearchData,
                fetchCarsData,
                getFormData,
                getSearchResults,
                getFilters,
                resetFilters,
                applyFilters,
                resetSearchId,
                loadMore,
                getPopularLocations,
                setSortingFilterValue,
            };

            function setSortingFilterValue(sort) {
                Object.assign(filters, sort);
            }

            function getSearchData(params) {
                return fetchCarsData(params).then(function() {
                    return {formData, searchResults};
                });
            }

            function fetchCarsData(params) {
                if (formData && formData.SearchId) {
                    params.SearchId = formData.SearchId;
                }
                formData = angular.copy(params);

                const request = _.extend(angular.copy(params), filters);

                return createSearchRequest(request)
                    .then(processCarResults);
            }

            function processCarResults({data}) {
                addSearchId(data.Cars, data.SearchId);

                searchResults = {
                    cars: data.Cars,
                    filters: data.Filters,
                    matrix: prepareCarMatrixFactory(data.FareComparisonMatrix),
                    total: data.Total,
                    filteredTotal: data.FilteredTotal,
                    rentalPeriod: data.RentalPeriod,
                    searchId: data.SearchId,
                };
                formData.SearchId = data.SearchId;
                return searchResults;
            }

            function createSearchRequest(params) {
                return $http.apiGET('/cars/Search', {params, timeout: appCONST.productSearchTimeout});
            }

            function addSearchId(elements, searchId) {
                _.forEach(elements, function(element) {
                    element.searchId = searchId;
                });
            }

            function applyFilters(newFilters) {
                filters = newFilters;
            }

            function resetFilters() {
                filters = angular.copy(defaultFilters);
                this.filtersApplied = false;
            }

            function getFilters() {
                return filters;
            }

            function resetSearchId() {
                if (formData) {
                    delete formData.SearchId;
                }
            }

            function getSearchResults() {
                return searchResults;
            }

            function getFormData() {
                return formData;
            }

            function getPopularLocations(pickUpLongitude, pickUpLatitude) {
                const params = {};
                if (pickUpLatitude && pickUpLongitude) {
                    params.pickUpLongitude = pickUpLongitude;
                    params.pickUpLatitude = pickUpLatitude;
                }
                return $http.apiGET('/Authorize/GetFrequentLocationsForCars', {params, noSpinner: true});
            }

            function loadMore(limit, offset) {
                const requestParams = angular.copy($stateParams);

                requestParams.Max = limit;
                requestParams.Min = offset;

                if (formData.SearchId) {
                    requestParams.SearchId = formData.SearchId;
                }

                _.extend(requestParams, filters);

                return createSearchRequest(requestParams)
                    .then(processCarResults);
            }

            function getFunctionForLoadPreviousSearches(amount) {
                return function() {
                    const endpoint = '/UserSearchParameters/UserSearch/AllCars';
                    const params = {
                            topResults: amount,
                        };

                    return $http.apiGET(endpoint, {params, noSpinner: true});
                };
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/services/carsFactory.js